import CryptoJS from 'crypto-js';

// 固定32位密钥（必须和Java端完全一致）
const FIXED_KEY = process.env.VUE_APP_AES_KEY;
// 编码格式（和Java端统一）
const CHARSET = CryptoJS.enc.Utf8;
export function aesEncrypt() {
    /**
     * AES-256-CBC加密
     * @param {string} plainText 待加密字符串
     * @returns {string} 加密后字符串（格式：Base64(IV):Base64(密文)）
     */
    const encrypt = (plainText) => {
        // 1. 生成16位随机IV（和Java端一致）
        const iv = CryptoJS.lib.WordArray.random(16);
        // 2. 转换密钥和IV格式
        const key = CryptoJS.enc.Utf8.parse(FIXED_KEY);
        // 3. 加密
        const encrypted = CryptoJS.AES.encrypt(plainText, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC, // CBC模式
            padding: CryptoJS.pad.Pkcs7 // PKCS5Padding和PKCS7Padding兼容
        });
        // 4. IV和密文分别Base64编码，拼接返回
        const ivBase64 = iv.toString(CryptoJS.enc.Base64);
        const encryptedBase64 = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
        return `${ivBase64}:${encryptedBase64}`;
    }

    /**
     * AES-256-CBC解密
     * @param {string} cipherText 加密后的字符串（格式：Base64(IV):Base64(密文)）
     * @returns {string} 解密后的原文
     */
    const decrypt = (cipherText) => {
        try {
            // 1. 拆分IV和密文
            const [ivBase64, encryptedBase64] = cipherText.split(':', 2);
            if (!ivBase64 || !encryptedBase64) {
                throw new Error('加密字符串格式错误');
            }
            // 2. 转换格式
            const key = CryptoJS.enc.Utf8.parse(FIXED_KEY);
            const iv = CryptoJS.enc.Base64.parse(ivBase64);
            const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedBase64);
            // 3. 解密
            const decrypted = CryptoJS.AES.decrypt(
                { ciphertext: encryptedBytes },
                key,
                {
                    iv: iv,
                    mode: CryptoJS.mode.CBC,
                    padding: CryptoJS.pad.Pkcs7
                }
            );
            // 4. 转原文
            return decrypted.toString(CHARSET);
        } catch (e) {
            console.error('解密失败：', e);
            return '';
        }
    }

    return {
        encrypt,
        decrypt
    }
}